import { gql } from '@apollo/client';

export const UPDATE_INCIDENT_REVIEW_ALL_FIELDS = gql`
  mutation updateIncidentReview($input: UpdateIncidentReviewInput!) {
    updateIncidentReview(input: $input) {
      clientMutationId
      errors
      incidentReviewUuid
      incidentUuid
      incidentReview {
        approvalStatus {
          id
          name
          oriId
          position
        }
        fulfilled
        id
        incidentDispositionType {
          id
          name
          oriId
          position
        }
        investigatingOfficer {
          id
          deptAttribute {
            badge
            ori {
              id
              oriName
              abbreviation
            }
            id
          }
          personalAttribute {
            firstName
            lastName
            middleName
          }
        }
        keepInOfficerQueue
        keepInQueue
        nfirsCode {
          id
          name
          oriId
          position
        }
        nibrsCheck
        nibrsReviewed
        reviewComments
        reviewDate
        reviewStatus {
          id
          name
          oriId
          position
        }
        reviewingSupervisor {
          id
          deptAttribute {
            badge
            ori {
              id
              oriName
              abbreviation
            }
            id
          }
          personalAttribute {
            firstName
            lastName
            middleName
          }
        }
        sentToRecords
        sentToRecordsAt
        statusDate
        submitToOri {
          abbreviation
          agencyType
          id
          oriName
          saOri {
            id
            abbreviation
            agencyType
            oriName
          }
          tokenDisabled
        }
        submittedAt
      }
    }
  }
`